import React from "react";
// import { useEffect, useState }  from "react";

import { Button, ButtonGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { isMobile } from 'react-device-detect';

import { ColumnType } from './DataTable/DataTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageButtonType } from "src/datatypes/datatypes";
import { useDataTableContext } from "./DataTableEngine/shared/Context";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { faColumns3 } from "@fortawesome/pro-regular-svg-icons";  
import { View } from "./DataTableEngine/shared/interface"; 
import { faArrowsAltV } from "@fortawesome/pro-solid-svg-icons";
import { faEllipsisV } from "@fortawesome/pro-solid-svg-icons";

interface pageButtonProps {
    pageButtons: PageButtonType[];
    columns?:ColumnType[];
    scope?: string;
    dataTableView?: string;
}
const PageButtonsComponent: React.FC<pageButtonProps> = ({ pageButtons, columns, scope, dataTableView }) => {
    if(isMobile) {
        return <RenderPageButtonSmallScreen pageButtons={pageButtons} columns={columns}  />;
    }else {
        return <RenderPageButton pageButtons={pageButtons}  columns={columns} scope={scope} dataTableView={dataTableView} />
    }
}

export { PageButtonsComponent }

// FIXME: fix the template

const RenderPageButton: React.FC<any> = ({ pageButtons, columns, scope, dataTableView }) => {

    const{TableView, setTableView,setVisibleColumnList,setHiddenColumnList, rowHeight, setRowHeight, COLUMN_FIELDS_REF, VIEW_FIELDS_REF, maxContentHeight, ROW_HEIGHT_OPTION_PADDING_TOP } = useDataTableContext();
 
    const gridView = (view) => {
        setTableView(view);
        const hide = [];
        COLUMN_FIELDS_REF.current?.forEach((_, field) => {
            if (!VIEW_FIELDS_REF.current?.[view]?.has(field)) {
                hide.push(field);
            }
        });
      setVisibleColumnList(Array.from(VIEW_FIELDS_REF.current?.[view]) ?? []);
      setHiddenColumnList(hide);
    };
 
    const buttonList = pageButtons.filter(pb => pb.visible ? pb.visible() : true).map(function(pageButton, index) {
        const uniqueBaseKey = `${pageButton.type}-${pageButton.title || index}`;
        if (pageButton.type === 'button_with_group') {
            const buttonGroupArr = pageButton?.value?.split(',')
            const buttonGroupArrTitle = pageButton?.title?.split(',')
            return (
            <div
            key={uniqueBaseKey}
            style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "4px",
                marginBottom: "1px",
            }}
            >
            <div
            style={{
                height: "30px",
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "2px",
                display: "flex",
                alignItems: "center",
            }}
            >
                <ButtonGroup
                    style={{
                    height: "100%",
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    }}
                >
                    {buttonGroupArr.map((buttonGroup, index) => {
                    const isActive = buttonGroup === View[TableView];
                    return (
                        <Button
                        key={`button-${buttonGroup}-${index}`}
                        onClick={() => {
                            const viewValue = View[buttonGroup as keyof typeof View];
                            gridView(viewValue);
                        }}
                        style={{
                            lineHeight: "1",
                            padding: "0px 14px", 
                            fontSize: "14px",    
                            backgroundColor: isActive ? "#212529" : "transparent",
                            color: isActive ? "#ffffff" : "#000000",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: 500,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease-in-out",
                        }}
                        >
                        {buttonGroupArrTitle[index]}
                        </Button>
                    );
                    })}
                </ButtonGroup>
                </div>

                <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    float:'right',
                    marginLeft: "8px",
                    marginRight: "4px",
                    opacity: 0.4,
                    fontSize: "14px"
                }}
                >
                   <i className="fa-light fa-pipe" aria-hidden="true"></i>
                </div>
                
              </div>
            );
        } else if(pageButton.type === 'button_with_icon') {
            return (
                <React.Fragment key={uniqueBaseKey}>  
                    <div style={{marginLeft: "4px", marginBottom: "1px", float:'left'}}>
                        <Button size='sm' className= {pageButton.className ? pageButton.className : "text-nowrap"} title={pageButton.title} variant="dark" onClick={pageButton.action}>
                        {pageButton.icon &&  <FontAwesomeIcon className="mr-2" icon={pageButton.icon} />}
                            {pageButton.title}
                        </Button>
                    </div>
                </React.Fragment>
            );

        }else if(pageButton.type === 'button') {
            return (
                <div 
                key={uniqueBaseKey} 
                style={{marginLeft: "4px", marginBottom: "1px", float:'left'}}>
                    <Button size='sm' className="text-nowrap" title={pageButton.title} variant="outline-dark" onClick={pageButton.action}>
                    {pageButton.icon &&  <FontAwesomeIcon icon={pageButton.icon} />}
                    </Button>
                </div>
            );

        } else if(pageButton.type === 'button_with_text') {
            
            return (
                <div key={uniqueBaseKey}style={{marginLeft: "4px", marginBottom: "1px", float:'left'}}>
                    <Button size='sm' className="text-nowrap" title={pageButton.title} variant="outline-dark" onClick={pageButton.action}>
                        {pageButton.title}
                    </Button>
                </div>
            );

        } else if(pageButton.type === 'column') {
            return (
            <React.Fragment key={uniqueBaseKey}>  
                <div style={{ marginLeft: "4px"}}>

                <RenderColumnsButtons columns={columns} setSearchState={pageButton.setSearchState} key={index} scope={scope}/>
 
                </div>

                <OverlayTrigger
                    placement="top"
                    overlay={
                    <Tooltip id={`tooltip-drag-columns-${index}`}>
                        Drag & drop columns to rearrange view
                    </Tooltip>
                    }
                >
                    <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        float: 'right',
                        marginLeft: '8px',
                        marginRight: '4px',
                        opacity: 0.6,
                        fontSize: '14px',
                        cursor: 'pointer',
                    }}
                    >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    </div>
                </OverlayTrigger>
                </React.Fragment>
                )

        }
        else if(pageButton.type === 'row_height') {
            const ROW_HEIGHT = {
                SMALL: 35,
                MEDIUM: 150,
                LARGE: 300,
            } as const;

            return (
                <div 
                    key={uniqueBaseKey} 
                    style={{
                        marginLeft: "4px", 
                        float: "left", 
                        display: "flex", 
                        alignItems: "center", 
                        gap: "8px",
                        height: "30px",
                    }}
                >
                    {/* Row 1: Auto-fit button (outside dropdown) */}
                    <div className="d-flex align-items-center flex-row">
                        <Button
                            size="sm"
                            variant="outline-dark"
                            style={{
                                fontSize: "12px",
                                width: "90px",
                                fontWeight: "500",
                            }}
                            disabled={maxContentHeight + ROW_HEIGHT_OPTION_PADDING_TOP === rowHeight}
                            onClick={() => setRowHeight(maxContentHeight + ROW_HEIGHT_OPTION_PADDING_TOP)}
                            title={`Set auto row height`}
                        >
                                <FontAwesomeIcon icon={faArrowsAltV} /> {`Auto-fit`}
                        </Button>
                    </div>
                    {/* Row 2: Dropdown for preset sizes */}
                    <Dropdown>
                        <Dropdown.Toggle
                            size="sm"
                            variant="outline-dark"
                            style={{
                                minWidth: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                height: "30px",
                                padding: 0,
                                fontSize: "20px",
                            }}
                            className="no-caret"
                            title={`More row height options`} 
                        >
                            <FontAwesomeIcon icon={faEllipsisV} style={{ fontSize: "12px", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ minWidth: "100px", padding: "8px" }}>
                            <div className="px-2 py-2">
                                <div 
                                    className="d-flex flex-column" 
                                    style={{ gap: "6px" }}
                                >
                                    <Button
                                        size="sm"
                                        variant={rowHeight === ROW_HEIGHT.SMALL ? "dark" : "outline-dark"}
                                        onClick={() => setRowHeight(ROW_HEIGHT.SMALL)}
                                        style={{ width: "100%" }}
                                    >
                                        Small
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant={rowHeight === ROW_HEIGHT.MEDIUM ? "dark" : "outline-dark"}
                                        onClick={() => setRowHeight(ROW_HEIGHT.MEDIUM)}
                                        style={{ width: "100%" }}
                                    >
                                        Medium
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant={rowHeight === ROW_HEIGHT.LARGE ? "dark" : "outline-dark"}
                                        onClick={() => setRowHeight(ROW_HEIGHT.LARGE)}
                                        style={{ width: "100%" }}
                                    >
                                        Large
                                    </Button>
                                </div>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            );
        }

        else if(pageButton.type === 'dropdown_only_icon') {
            
            return (
                <React.Fragment key={uniqueBaseKey}> 
                    <RenderDropDownButton pageButton={pageButton}   />
                </React.Fragment>
                )

        }
        else if (pageButton.type === 'separator') {
            return (
                <div
                key={`separator-${index}`}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '30px',
                    marginLeft: '8px',
                    marginRight: '4px',
                    opacity: 0.4,
                    fontSize: '14px',
                }}
                >
                <i className="fa-light fa-pipe" aria-hidden="true"></i>
                </div>
            );
        } else {
            return (
                <React.Fragment key={uniqueBaseKey}> 
                    <RenderDropDownButton pageButton={pageButton}   />
                </React.Fragment>
                )        
        }
    })
    
    return buttonList;
}


interface RenderPageButtonSmallScreenProps {
    pageButtons: PageButtonType[];
    columns?:ColumnType[];
}

const RenderPageButtonSmallScreen: React.FC<RenderPageButtonSmallScreenProps> = ({ pageButtons }) => {

    const buttonList = pageButtons.map(function(pageButton, index) {
        if(pageButton.type === 'button_with_icon' || pageButton.type === 'button') {
            return (
               
                <Dropdown.Item key={index} onClick={pageButton.action}> {pageButton.icon &&  <FontAwesomeIcon className="mr-2" icon={pageButton.icon} />} {pageButton.title}</Dropdown.Item>
            
            );
        } else if( pageButton.type === 'button_with_text') {
            return (
                <Dropdown.Item key={index} onClick={pageButton.action}>{

                    isMobile &&  <FontAwesomeIcon className="mr-2 invisible" icon={pageButton.icon} />}
                        {pageButton.title}
                </Dropdown.Item>
            );
        }else {
            return null;
        }

    })


    const dropDownButtonList = pageButtons.map(function(pageButton, index) {

        if(pageButton.type !== 'button') {
            return (
                <div  key={index} style={{marginRight:'1px'}}>
                    <RenderDropDownButton pageButton={pageButton} />
                </div>
            );
        }else {
            return null;
        }

    })

    return (
            <div style={{display:'flex', flexDirection: 'row'}}>
                <div style={{margin:'2px'}}>
                    <Dropdown>
                        <Dropdown.Toggle  size='sm' variant="outline-dark" id="dropdown-basic">
                            More
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {buttonList}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div>
                    {dropDownButtonList}
                </div>
            </div>
            )
}


interface RenderColumnsButtonsProps {
    columns?:  ColumnType[];
    setSearchState?:(prevSearchStates: any) => void;
    scope?:string;
}


const RenderColumnsButtons: React.FC<RenderColumnsButtonsProps> = () => {
  
    const { visibleColumnList, setVisibleColumnList, hiddenColumnList, setHiddenColumnList,setColumnVisible,setColumnHidden, COLUMN_FIELDS_REF, VIEW_FIELDS_REF, TableView } = useDataTableContext();
    let visLst = visibleColumnList.length > 0 ? visibleColumnList : Array.from(VIEW_FIELDS_REF.current?.[TableView] ?? []);

  return (
    <Dropdown>
      <Dropdown.Toggle
        size="sm"
        variant="outline-dark"
        id="dropdown-basic"
        className="no-caret"
      >
        <FontAwesomeIcon icon={faColumns3} />
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto', minWidth: '220px' }}>
        
       { COLUMN_FIELDS_REF.current && Array.from(COLUMN_FIELDS_REF.current?.entries() ?? []).map(([colId, headerName], index) => {
        const checked = visLst?.includes(colId);
        return (
            <div key={index} className="d-flex align-items-center px-2 py-1">
            <input
                type="checkbox"
                className="form-check-input me-2 grey-checkbox"
                id={colId}
                checked={checked}
                onChange={(event) => {
                const isChecked = event.target.checked;
                const fieldName = event.target.id;

                const newVisible = new Set(visLst);
                const newHidden = new Set(hiddenColumnList);

                if (isChecked) {
                    newVisible.add(fieldName);
                    newHidden.delete(fieldName);
                    setColumnVisible(fieldName);
                } else {
                    newVisible.delete(fieldName);
                    newHidden.add(fieldName);
                    setColumnHidden(fieldName);
                }

                setVisibleColumnList(Array.from(newVisible));
                setHiddenColumnList(Array.from(newHidden));
                }}
            />
            <label htmlFor={colId} className="form-check-label">
                {headerName}
            </label>
            </div>
        );
        })}

      </Dropdown.Menu>
    </Dropdown>
  );
};

interface RenderDropDownButtonProps {
    pageButton: PageButtonType;
    
}


const RenderDropDownButton: React.FC<RenderDropDownButtonProps> = ( props ) => {

    if(!props.pageButton.dropDownItems) return null;

    return (
        <div  style={{marginLeft: "4px", marginBottom: "1px", float:'left'}}>
            <Dropdown className={props.pageButton.className ? props.pageButton.className : ''}>
                <Dropdown.Toggle size='sm' variant="outline-dark" id="dropdown-basic" title={props.pageButton.title}>
                    {props.pageButton.type === 'dropdown_only_icon' &&  <FontAwesomeIcon icon={props.pageButton.icon} />}
                    {props.pageButton.type === 'dropdown' && props.pageButton.title}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {props.pageButton.dropDownItems.map(function(item, index) {
                        if (!Object.keys(item).includes("visible") || item.visible) {
                            return (<Dropdown.Item onClick={ () => { item.action() } } key={index}>{item.icon && <FontAwesomeIcon icon={item.icon} style={ item.style ? item.style : { marginRight: '8px' }} />}{item.title}</Dropdown.Item>)  
                        }  else { 
                            return null
                        }
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

